import angular from 'angular'
import './storyboards.service'

angular
  .module('admin.storyboard_elements', ['admin.storyboard_elements.service'])
  .controller('StoryboardElementsCtrl', StoryboardElementsCtrl)

/** @ngInject */
function StoryboardElementsCtrl($scope, $state, $stateParams, StoryboardElementsService) {
  var vm = this
  vm.editing = false
  vm.elements = []
  vm.types = []
  vm.shelves = []
  vm.accessories = []
  vm.overlays = []
  vm.onlyNumbers = /^(0|[1-9]\d*)(\.\d+)?$/

  var tab = localStorage.getItem('storyboard_elements_tab')
  if (tab !== null) {
    if (tab === 'elementType') {
      $('#shelves').removeClass('active')
      $('#accessories').removeClass('active')
      $('#overlays').removeClass('active')
      $('#elementType').addClass('active')
      $('#elementTypeTab').addClass('active')
    } else if (tab === 'shelves') {
      $('#elementType').removeClass('active')
      $('#accessories').removeClass('active')
      $('#overlays').removeClass('active')
      $('#shelves').addClass('active')
      $('#shelvesTab').addClass('active')
    } else if (tab === 'accessories') {
      $('#elementType').removeClass('active')
      $('#shelves').removeClass('active')
      $('#overlays').removeClass('active')
      $('#accessories').addClass('active')
      $('#accessoriesTab').addClass('active')
    } else {
      $('#elementType').removeClass('active')
      $('#shelves').removeClass('active')
      $('#accessories').removeClass('active')
      $('#overlays').addClass('active')
      $('#overlaysTab').addClass('active')
    }
  } else {
    $('#elementType').addClass('active')
    $('#elementTypeTab').addClass('active')
    localStorage.setItem('storyboard_elements_tab', 'elementType')
  }

  vm.tabElements = function() {
    $('#shelves').removeClass('active')
    $('#accessories').removeClass('active')
    $('#overlays').removeClass('active')
    $('#elementType').addClass('active')
    localStorage.setItem('storyboard_elements_tab', 'elementType')
  }

  vm.tabShelves = function() {
    $('#elementType').removeClass('active')
    $('#accessories').removeClass('active')
    $('#overlays').removeClass('active')
    $('#shelves').addClass('active')
    localStorage.setItem('storyboard_elements_tab', 'shelves')
  }

  vm.tabAccessories = function() {
    $('#elementType').removeClass('active')
    $('#shelves').removeClass('active')
    $('#overlays').removeClass('active')
    $('#accessories').addClass('active')
    localStorage.setItem('storyboard_elements_tab', 'accessories')
  }

  vm.tabOverlays = function() {
    $('#elementType').removeClass('active')
    $('#shelves').removeClass('active')
    $('#accessories').removeClass('active')
    $('#overlays').addClass('active')
    localStorage.setItem('storyboard_elements_tab', 'overlays')
  }

  function load() {
    StoryboardElementsService.listElementTypes().then(function(result) {
      vm.types = result
      vm.types.forEach(function(item) {
        item.editing = false
      })

      StoryboardElementsService.listElements().then(function(resultElements) {
        var elements = resultElements
        var shelves = elements.results ? elements.results.backgrounds : []
        var accessories = elements.results ? elements.results.accessories : []
        var overlays = elements.results ? elements.results.overlays : []
        shelves.forEach(function(item, index) {
          item.editing = false
          for (var i = 0; i < vm.types.length; i++) {
            if (_.isEqual(item.shelves, vm.types[i].types)) {
              item.shelf = vm.types[i].name
              break
            } else {
              item.shelf = null
            }
          }
          if (index === 0) {
            item.firstRow = true
          }

          if (shelves.length - 1 === index) {
            item.lastRow = true
          }
        })
        accessories.forEach(function(item, index) {
          if (index === 0) {
            item.firstRow = true
          }

          if (accessories.length - 1 === index) {
            item.lastRow = true
          }
          item.editing = false
        })
        overlays.forEach(function(item, index) {
          if (index === 0) {
            item.firstRow = true
          }

          if (overlays.length - 1 === index) {
            item.lastRow = true
          }
          item.editing = false
        })

        vm.elements = elements
        vm.shelves = shelves
        vm.accessories = accessories
        vm.overlays = overlays

        var ele = {
          results: {
            accessories: accessories,
            backgrounds: shelves,
            overlays: overlays,
          },
        }
        StoryboardElementsService.saveElements(ele).then(function() {})
      })
    })
  }

  load()

  function updateElements() {
    if (!vm.elements.results) {
      return
    }
    vm.shelves.map(function(item) {
      delete item.firstRow
      delete item.lastRow
      delete item.$$hashKey
      delete item.editing
    })
    vm.accessories.map(function(item) {
      delete item.firstRow
      delete item.lastRow
      delete item.$$hashKey
      delete item.editing
    })
    vm.overlays.map(function(item) {
      delete item.firstRow
      delete item.lastRow
      delete item.$$hashKey
      delete item.editing
    })

    vm.elements.results.shelves = vm.shelves
    vm.elements.results.accessories = vm.accessories
    vm.elements.results.overlays = vm.overlays
  }

  vm.add = function() {
    var tab = localStorage.getItem('storyboard_elements_tab')
    if (tab === null) {
      tab = 'elementType'
    }
    switch (tab) {
      case 'elementType':
        $('#modalElementTypeName').modal('show')
        vm.elementTypeName = null
        break
      case 'accessories':
        $('#modalAccessoryName').modal('show')
        vm.accessoryName = null
        break
      case 'shelves':
        $('#modalShelveName').modal('show')
        vm.shelveName = null
        break
      case 'overlays':
        $('#modalOverlayName').modal('show')
        vm.overlayName = null
        break
      default:
        $('#modalElementTypeName').modal('show')
        vm.elementTypeName = null
        break
    }
  }

  // element types manager
  vm.saveTypeName = function() {
    if (vm.editing) return
    vm.editing = true
    if (
      vm.elementTypeName === null ||
      vm.elementTypeName === undefined ||
      vm.elementTypeName === ''
    ) {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    var copy = angular.copy(vm.types)
    var exist = _.some(copy, function(item) {
      if (item.name) {
        if (item.name.toLowerCase() === vm.elementTypeName.toLowerCase()) {
          return true
        }
      }
    })

    if (exist) {
      swal('The name already exist', '', 'error')
      vm.editing = false
      return
    }

    vm.creatingType = true
    vm.typeItem = {
      name: vm.elementTypeName,
      types: [],
    }
    vm.types.unshift(vm.typeItem)
    StoryboardElementsService.saveElementType(vm.types).then(function() {
      toastr.success('Created!')
      $('#modalElementTypeName').modal('hide')
      $('#modalElementType').modal('show')
      vm.editing = false
    })
  }

  vm.editType = function(item) {
    $('#modalElementType').modal('show')
    vm.typeItem = item
  }

  vm.editTypeRow = function(item) {
    item.editing = !item.editing
    vm.editing = true
  }

  vm.closeType = function() {
    if (vm.creatingType) {
      vm.types.remove(vm.typeItem)
      StoryboardElementsService.saveElementType(vm.types).then(function() {
        $('#modalElementType').modal('hide')
        vm.creatingType = false
      })
    } else {
      vm.creatingType = false
      load()
      $('#modalElementType').modal('hide')
    }
  }

  vm.addType = function(item) {
    item.types.unshift({
      y: null,
      x: null,
      scale: null,
      editing: true,
    })
    vm.editing = true
  }

  vm.deleteType = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          vm.types.remove(item)
          StoryboardElementsService.saveElementType(vm.types).then(function() {
            toastr.success('Deleted!')
          })
        }
      },
    )
  }

  vm.saveType = function(item, row) {
    if (row.x === null && row.y === null && row.scale === null) {
      swal('You need to fill some field', '', 'warning')
      return
    }

    if (!vm.onlyNumbers.test(row.y)) {
      swal('Only Numeric Characters are supported', '', 'warning')
      return
    }

    if (!vm.onlyNumbers.test(row.x)) {
      swal('Only Numeric Characters are supported', '', 'warning')
      return
    }

    if (!vm.onlyNumbers.test(row.scale)) {
      swal('Only Numeric Characters are supported', '', 'warning')
      return
    }

    var types = angular.copy(vm.types)
    for (var i = 0; i < types.length; i++) {
      if (types[i].name === item.name) {
        types[i].types = item.types
      }
      for (var j = 0; j < types[i].types.length; j++) {
        delete types[i].types[j].$$hashKey
        delete types[i].types[j].editing
      }
      delete types[i].$$hashKey
      delete types[i].editing
    }
    vm.editing = false
    StoryboardElementsService.saveElementType(types).then(function() {
      toastr.success('Updated!')
      vm.creatingType = false
      load()
      delete row.editing
    })
  }

  vm.saveNameType = function() {
    if (!vm.typeItem.name) {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    var types = angular.copy(vm.typeItem.types)
    for (var i = 0; i < types.length; i++) {
      if (types[i].editing) {
        swal('Do you need to save the row being edited', '', 'warning')
        return
      }
    }

    StoryboardElementsService.saveElementType(vm.types).then(function() {
      toastr.success('Updated!')
      $('#modalElementType').modal('hide')
      vm.creatingType = false
      load()
    })
  }

  vm.deleteTypeRow = function(data, item, index) {
    var types = angular.copy(vm.types)
    data.types.remove(item)
    for (var i = 0; i < types.length; i++) {
      if (types[i].name === data.name) {
        types[i].types = data.types
        break
      }
    }
    vm.editing = false
    StoryboardElementsService.saveElementType(types).then(function() {
      toastr.success('Deleted!')
      vm.types = types
      delete item.editing
    })
  }

  vm.cancelTypeRow = function(data, item) {
    if (item.x === null && item.y === null && item.scale === null) {
      data.types.remove(item)
    } else {
      delete item.editing
    }
    vm.editing = false
  }
  // end element types manager

  // shelves manager
  vm.loadShelveImgL = false
  vm.pathShelveImgL = ''
  vm.saveShelveName = function() {
    if (vm.editing) return
    vm.editing = true
    if (vm.shelveName === null || vm.shelveName === undefined || vm.shelveName === '') {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }
    var copy = angular.copy(vm.shelves)
    var exist = _.some(copy, function(item) {
      if (item.name.toLowerCase() === vm.shelveName.toLowerCase()) {
        return true
      }
    })

    if (exist) {
      swal('The name already exist', '', 'error')
      vm.editing = false
      return
    }

    vm.creatingShelve = true
    vm.shelveItem = {
      name: vm.shelveName,
      shelf: '',
      'img-l': '',
      shelves: [],
    }
    vm.shelves.unshift(vm.shelveItem)
    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      toastr.success('Created!')
      $('#modalShelveName').modal('hide')
      $('#modalShelve').modal('show')
      vm.editing = false
    })
  }

  vm.editShelve = function(item) {
    $('#modalShelve').modal('show')
    vm.shelveItem = item
    vm.shelveItemBkp = angular.copy(item)
  }

  vm.closeShelve = function() {
    if (vm.creatingShelve) {
      vm.shelves.remove(vm.shelveItem)
      StoryboardElementsService.saveElements(vm.elements).then(function() {
        $('#modalShelve').modal('hide')
        vm.creatingShelve = false
      })
    } else {
      vm.creatingShelve = false
      if (!vm.shelveItem.name) {
        vm.shelveItem.name = vm.shelveItemBkp.name
      }
      $('#modalShelve').modal('hide')
    }
  }

  vm.deleteShelve = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          vm.shelves.remove(item)
          updateElements()
          StoryboardElementsService.saveElements(vm.elements).then(function() {
            toastr.success('Deleted!')
          })
        }
      },
    )
  }

  vm.uploadShelveImgL = function(item) {
    vm.loadShelveImgL = true
    StoryboardElementsService.uploadShelveImgL(vm.pathShelveImgL).then(function(fileName) {
      vm.loadShelveImgL = false
      item['img-l'] = fileName
    })
  }

  vm.saveShelve = function() {
    if (!vm.shelveItem.name) {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    var type = _.find(vm.types, { name: vm.shelveItem.shelf })
    if (type !== undefined) {
      vm.shelveItem.shelves = type.types
    }
    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      toastr.success('Saved!')
      vm.creatingShelve = false
      load()
      $('#modalShelve').modal('hide')
    })
  }
  // end shelves manager

  // accessories manager
  vm.loadAccessoryImgL = false
  vm.pathAccessoryImgL = ''
  vm.loadAccessoryImgHi = false
  vm.pathAccessoryImgHi = ''
  vm.saveAccessoryName = function() {
    if (vm.editing) return
    vm.editing = true
    if (vm.accessoryName === null || vm.accessoryName === undefined || vm.accessoryName === '') {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    var copy = angular.copy(vm.accessories)
    var exist = _.some(copy, function(item) {
      if (item.name) {
        if (item.name.toLowerCase() === vm.accessoryName.toLowerCase()) {
          return true
        }
      }
    })

    if (exist) {
      swal('The name already exist', '', 'error')
      vm.editing = false
      return
    }

    vm.accessoryItem = {
      name: vm.accessoryName,
      shelf: '',
      'img-l': '',
      'img-hi-res': '',
      scale: 0,
    }

    vm.accessories.unshift(vm.accessoryItem)

    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      toastr.success('Created!')
      vm.accessoryName = null
      vm.editing = false
      $('#modalAccessoryName').modal('hide')
      $('#modalAccessory').modal('show')
    })
  }

  vm.editAccessory = function(item) {
    $('#modalAccessory').modal('show')
    vm.accessoryItem = item
  }

  vm.deleteAccessory = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          vm.accessories.remove(item)
          updateElements()
          StoryboardElementsService.saveElements(vm.elements).then(function() {
            toastr.success('Deleted!')
          })
        }
      },
    )
  }

  vm.uploadAccessoryImgL = function(item) {
    vm.loadAccessoryImgL = true
    StoryboardElementsService.uploadAccessoryImg(vm.pathAccessoryImgL).then(function(fileName) {
      vm.loadAccessoryImgL = false
      item['img-l'] = fileName
    })
  }

  vm.uploadAccessoryImgHi = function(item) {
    vm.loadAccessoryImgHi = true
    StoryboardElementsService.uploadAccessoryImg(vm.pathAccessoryImgHi).then(function(fileName) {
      vm.loadAccessoryImgHi = false
      item['img-hi-res'] = fileName
    })
  }

  vm.saveAccessory = function(row) {
    if (!vm.accessoryItem.name) {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    if (!vm.accessoryItem.scale) {
      swal('Missing Scale! Please add a SCALE before saving.', '', 'warning')
      return
    }

    if (!vm.onlyNumbers.test(row.scale)) {
      swal('Only Numeric Characters are supported', '', 'warning')
      return
    }

    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      toastr.success('Saved!')
      load()
      $('#modalAccessory').modal('hide')
    })
  }

  vm.closeAccessory = function() {
    load()
    $('#modalAccessory').modal('hide')
  }
  // end accessories manager

  // overlays manager
  vm.loadOverlayImgT = false
  vm.loadOverlayImgL = false
  vm.pathOverlayImgT = ''
  vm.pathOverlayImgL = ''
  vm.saveOverlayName = function() {
    if (vm.editing) return
    vm.editing = true
    if (vm.overlayName === null || vm.overlayName === undefined || vm.overlayName === '') {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    var copy = angular.copy(vm.overlays)
    var exist = _.some(copy, function(item) {
      if (item.name) {
        if (item.name.toLowerCase() === vm.overlayName.toLowerCase()) {
          return true
        }
      }
    })

    if (exist) {
      swal('The name already exist', '', 'error')
      vm.editing = false
      return
    }

    vm.overlayItem = {
      name: vm.overlayName,
      'img-t': '',
      'img-l': '',
    }
    vm.overlays.unshift(vm.overlayItem)
    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      toastr.success('Created!')
      vm.editing = false
      $('#modalOverlayName').modal('hide')
      $('#modalOverlay').modal('show')
    })
  }

  vm.editOverlay = function(item) {
    $('#modalOverlay').modal('show')
    vm.overlayItem = item
    vm.overlayItemBkp = angular.copy(item)
  }

  vm.deleteOverlay = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          vm.overlays.remove(item)
          updateElements()
          StoryboardElementsService.saveElements(vm.elements).then(function() {
            toastr.success('Deleted!')
          })
        }
      },
    )
  }

  vm.uploadOverlayImgT = function(item) {
    vm.loadOverlayImgT = true
    StoryboardElementsService.uploadOverlay(vm.pathOverlayImgT).then(function(fileName) {
      vm.loadOverlayImgT = false
      item['img-t'] = fileName
    })
  }

  vm.uploadOverlayImgL = function(item) {
    vm.loadOverlayImgL = true
    StoryboardElementsService.uploadOverlay(vm.pathOverlayImgL).then(function(fileName) {
      vm.loadOverlayImgL = false
      item['img-l'] = fileName
    })
  }

  vm.saveOverlay = function() {
    if (!vm.overlayItem.name) {
      swal('Missing Name! Please add a NAME before saving.', '', 'warning')
      return
    }

    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      toastr.success('Saved!')
      load()
      $('#modalOverlay').modal('hide')
    })
  }

  vm.cancelOverlay = function() {
    if (!vm.overlayItem.name) {
      vm.overlayItem.name = vm.overlayItemBkp.name
    }
    $('#modalOverlay').modal('hide')
  }

  vm.shelveArrowUp = function(item, index) {
    var goToFoward = vm.shelves[index]

    vm.shelves[index] = vm.shelves[index - 1]
    vm.shelves[index - 1] = goToFoward

    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      load()
    })
  }

  vm.shelveArrowDown = function(item, index) {
    var goToFoward = vm.shelves[index]

    vm.shelves[index] = vm.shelves[index + 1]
    vm.shelves[index + 1] = goToFoward

    updateElements()

    StoryboardElementsService.saveElements(vm.elements).then(function() {
      load()
    })
  }

  vm.acessoryArrowUp = function(item, index) {
    var goToFoward = vm.accessories[index]

    vm.accessories[index] = vm.accessories[index - 1]
    vm.accessories[index - 1] = goToFoward

    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      load()
    })
  }

  vm.acessoryArrowDown = function(item, index) {
    var goToFoward = vm.accessories[index]

    vm.accessories[index] = vm.accessories[index + 1]
    vm.accessories[index + 1] = goToFoward

    updateElements()

    StoryboardElementsService.saveElements(vm.elements).then(function() {
      load()
    })
  }

  vm.overlayArrowUp = function(item, index) {
    var goToFoward = vm.overlays[index]

    vm.overlays[index] = vm.overlays[index - 1]
    vm.overlays[index - 1] = goToFoward

    updateElements()
    StoryboardElementsService.saveElements(vm.elements).then(function() {
      load()
    })
  }

  vm.overlayArrowDown = function(item, index) {
    var goToFoward = vm.overlays[index]

    vm.overlays[index] = vm.overlays[index + 1]
    vm.overlays[index + 1] = goToFoward

    updateElements()

    StoryboardElementsService.saveElements(vm.elements).then(function() {
      load()
    })
  }
  // end accessories manager
}
